const defaultPieChartColors = [
    '#09A7D1',
    '#201744',
    '#DAD7E2',
    '#FED883',
    '#A71F6B',
    '#E63C4F',
    '#35246C',
]

export const clientThemeSofi = {
    mainLayout: {
        backgroundColor: '#f4f4f5',
        hover: {
            backgroundColor: '#09A7D1',
        },
    },
    topBar: {
        backgroundColor: '',
        contrastText: '',
        contrastLinkText: '#09A7D1',
        userIcon: '#FF3B29',
        brandLogo: {
            maxWidth: '120px',
            paddingTop: '0px',
        },
        menuBarIcon: {
            color: '#a1a1aa',
        },
    },
    sidebar: {
        fontSize: '14px',
        backgroundColor: '#121315',
        darkBackgroundColor: '#27272a',
        sideMenuActive: {
            backgroundColor: '#09A7D1',
            contrastText: '',
        },
        sideMenuHover: {
            backgroundColor: '',
            contrastText: '',
        },
    },
    footer: {
        backgroundColor: '',
        contrastText: '',
    },
    charts: {
        fill: '#09A7D1',
        stroke: '#09A7D1',
        lineCharts: {
            stroke: '#09A7D1',
            fill: '#09A7D1',
        },
        areaCharts: {
            gradient: {
                start: '#09A7D1',
                stop: '#09A7D1',
            },
            stroke: '#09A7D1',
            fill: '#09A7D1',
            chargebacksByPostDateChart: {
                stroke: '#09A7D1',
                fill: '#09A7D1',
            },
            newAlertsByDateChart: [
                {
                    stroke: '#201744',
                    fill: '#20174420',
                },
                {
                    stroke: '#09A7D1',
                    fill: '#09A7D120',
                },
                {
                    stroke: '#DAD7E2',
                    fill: '#DAD7E220',
                },
                {
                    stroke: '#FED883',
                    fill: '#FED88320',
                },
                {
                    stroke: '#A71F6B',
                    fill: '#A71F6B20',
                },
                {
                    stroke: '#E63C4F',
                    fill: '#E63C4F20',
                },
                {
                    stroke: '#35246C',
                    fill: '#35246C20',
                },
            ],
        },
        barCharts: {
            fill: '#201744',
            lowestBar: '#E63C4F',
            byPlatformBarChart: { fill: '#201744' },
            byBinBarChart: { fill: '#201744' },
            ertsByRevenueChart: {
                bar1Fill: '#FED883',
                bar2Fill: '#09A7D1',
            },
            averageTimetoFileDispute: { fill: '#09A7D1' },
        },
        lineBarCharts: {
            byNonUniqueCustomerLineBarChart: {
                barColor: '#09A7D1',
                lineColor: '#201744',
            },
        },
        heatmapCharts: {
            casesFiled: {
                low: '#09A7D1',
                mid: '#DAD7E2',
                high: '#A71F6B',
            },
        },
        pieCharts: {
            defaultPieChart: defaultPieChartColors,
            dashboardPieChart: defaultPieChartColors,
            byReasonCodePieChart: defaultPieChartColors,
            byReasonCodeDistributionPieChart: defaultPieChartColors,
            byCardTypePieChart: defaultPieChartColors,
            byLocationTypePieChart: defaultPieChartColors,
            byPlatformPerCardTypePieChart: defaultPieChartColors,
            byStatusPieChart: defaultPieChartColors,
            byWinLossPieChart: defaultPieChartColors,
        },
        radialBarCharts: {
            fill: '#09A7D1',
        },
    },
    lockAndUnlockButton: {
        lockButton: {},
        unlockButton: {},
    },
    lampColors: {
        green: '#57a537',
        red: '#cb2022',
        orange: '#d87707',
        yellow: '#d8d800',
        grey: 'grey',
    },
    uploadDnD: {
        borderColor: `#cb2022`,
        backgroundColor: `rgba(203,32,34,.1)`,
        labelColor: `#cb2022`,
    },
    metricTile: {
        arrow: {
            width: 28,
            height: 28,
        },
    },
    caseBuilder: {
        color: '#09A7D1',
        saveAndContinueBtn: {
            margin: '0px',
            fontWeight: 700,
            textTransform: 'capitalize',
            backgroundColor: '#09A7D1',

            '&:hover': {
                backgroundColor: '#09A7D1',
            },
        },
        submittingColor: '#3399CC',
    },
    accentAreaTopBorderAccent: {
        backgroundColor: '',
        borderRadius: '',
    },
    dateRangeContainer: {
        borderRadius: '',
        padding: '8px 7px',
    },
    selectionBox: {
        borderRadius: '4px',
    },
    formFields: {
        formLabel: {},
        formText: {
            standard: {
                color: '#27272a',
            },
            outlined: {
                fontSize: '',
            },
        },
    },
    labelTags: {
        borderRadius: '16px',
        backgroundColor: '#e4e4e7',
    },
    searchBar: {
        padding: '6px',
    },
    select: {
        hover: {
            color: 'inherit',
            backgroundColor: '#F4F4F4',
        },
    },
    buttons: {
        styleButton: {
            root: {
                textTransform: 'capitalize',
            },
            contained: {
                textTransform: 'capitalize',
            },
        },
        defaultButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#e4e4e7',
                color: '#27272a',
                '&:hover': {
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        textOrOutlinedButton: {
            variant: 'outlined',
            style: {
                border: '1px solid #DDE2EB !important',
                borderRadius: '4px !important',
                color: '#263238',
                fontWeight: 500,
                padding: '4px 10px',
                fontSize: '13px',
                '&:hover': {
                    backgroundColor: 'rgba(38, 50, 56, 0.04)',
                },
            },
        },
        greyButton: {
            variant: 'contained',
            style: {
                color: '#71717a',
                borderRadius: '4px',
                backgroundColor: '#d4d4d8',
                '&:hover': {
                    color: '#71717a',
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        greenButton: {
            variant: 'contained',
            style: {
                borderRadius: '4px',
                backgroundColor: '#31B98E',
                '&:hover': {
                    backgroundColor: '#23826F',
                },
            },
        },
        activeStateButton: {
            color: '#FFFFFF',
            backgroundColor: '#52525b',
        },
    },
    icons: {
        uploadIcon: '#3cb4e5',
        dnrAndRevertDnrIcon: '#3cb4e5',
        toggleUnlockIcon: '#75797b',
        toggleLockIcon: '#c80000',
        editUserIcon: '#2a7ea0',
        midPermissionIcon: '#714eb1',
        sitePermissionIcon: '#f88d2b',
        tempPasswordIcon: '#3cb4e5',
    },
    main: '#09A7D1',
    primaryLight: '#09A7D1',
    primary: '#09A7D1',
    primaryDark: '#09A7D1',
    secondaryLight: '#09A7D1',
    secondary: '#09A7D1',
    secondaryDark: '#09A7D1',
    hyperlink: '#09A7D1',
    textField: '#09A7D1',
    switch: '#09A7D1',
    typography: {
        fontColor: {
            primaryText: '',
            secondaryText: '',
        },
        fontFamily: ['Larsseit', 'Source Sans Pro', 'sans-serif'],
        fontFamilyConfig: {
            primary: 'Larsseit',
            fallback:
                'Source Sans Pro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Arial, sans-serif',
        },
        fontFamilyClass: 'larsseit-font',
        h1: {
            fontSize: '34px',
        },
        h2: {
            fontSize: '28px',
        },
        h3: {
            fontSize: '23px',
        },
        h4: {
            fontSize: '19px',
        },
        h5: {
            fontSize: '15px',
        },
        h6: {
            fontSize: '12px',
        },
        subtitle1: {
            fontSize: '15px',
        },
        subtitle2: {
            fontSize: '12px',
        },
        subtitle3: {
            fontSize: '15px',
        },
        subtitle4: {
            fontSize: '12px',
        },
        body1: {
            fontSize: '13px',
        },
        body2: {
            fontSize: '12px',
        },
        button1: {
            fontSize: '13px',
        },
        button2: {
            fontSize: '13px',
        },
        caption: {
            fontSize: '11px',
        },
        overline: {
            fontSize: '10px',
        },
        label: {
            fontSize: '13px',
        },
        dataGrid: {
            tableHeader: {
                fontSize: '12.8px',
            },
            tableBody: {
                fontSize: '13px',
                color: '#464646',
            },
            tableExpandable: {
                fontSize: '13px',
            },
        },
    },
    shadows: {
        brandShadowLight: 'rgba(9, 167, 209, .4)',
    },
}
